import React, { useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import axios from "../api/axios";

export default function BrandForm() {
  const { id } = useParams();
  const isEdit = Boolean(id);
  const navigate = useNavigate();

  const [form, setForm] = useState({
    name: "",
  });
  const [image, setImage] = useState(null);
  const [preview, setPreview] = useState(null);

  useEffect(() => {
    if (isEdit) {
      axios.get(`/admin/brands/${id}`).then((res) => {
        setForm({ name: res.data.name });
        if (res.data.image_url) setPreview(res.data.image_url);
      });
    }
  }, [id, isEdit]);

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleImageChange = (e) => {
    const file = e.target.files[0];
    setImage(file);
    setPreview(URL.createObjectURL(file));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const formData = new FormData();
    formData.append("name", form.name);
    if (image) formData.append("image", image);

    try {
      if (isEdit) {
        formData.append("_method", "PUT");
        await axios.post(`/admin/brands/${id}`, formData, {
          headers: { "Content-Type": "multipart/form-data" },
        });
        alert("Brand updated!");
      } else {
        await axios.post("/admin/brands", formData, {
          headers: { "Content-Type": "multipart/form-data" },
        });
        alert("Brand created!");
      }
      navigate("/admin/brands");
    } catch (err) {
      console.error("Error:", err.response?.data || err.message);
      alert("Something went wrong!");
    }
  };

  return (
    <div className="container mt-5">
      <div className="card shadow">
        <div className="card-header bg-primary text-white">
          <h4 className="mb-0">{isEdit ? "Edit Brand" : "Add Brand"}</h4>
        </div>
        <div className="card-body">
          <form onSubmit={handleSubmit} encType="multipart/form-data">
            {/* Name */}
            <div className="mb-3">
              <label className="form-label">Brand Name</label>
              <input
                type="text"
                name="name"
                value={form.name}
                onChange={handleChange}
                className="form-control"
                required
              />
            </div>

            {/* Image */}
            <div className="mb-3">
              <label className="form-label">Brand Image</label>
              <input
                type="file"
                accept="image/*"
                className="form-control"
                onChange={handleImageChange}
              />
              {preview && (
                <img
                  src={preview}
                  alt="Preview"
                  className="img-thumbnail mt-2"
                  style={{ width: "100px", height: "100px", objectFit: "cover" }}
                />
              )}
            </div>

            <button type="submit" className="btn btn-success">
              {isEdit ? "Update Brand" : "Create Brand"}
            </button>
          </form>
        </div>
      </div>
    </div>
  );
}
